import React from 'react';
import { Link } from 'react-router-dom';
import { APP_NAME } from '../config/branding';
import './Footer.css';

const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <div className="footer-logo">
                            <span className="logo-icon">💰</span>
                            <span className="logo-text">{APP_NAME}</span>
                        </div>
                        <p className="footer-description">
                            Kişisel finans yönetimini kolaylaştıran modern ve kullanıcı dostu uygulama.
                        </p>
                    </div>

                    <div className="footer-section">
                        <h3>Hızlı Linkler</h3>
                        <ul className="footer-links">
                            <li><Link to="/">Ana Sayfa</Link></li>
                            <li><Link to="/help-support">Yardım & Destek</Link></li>
                            <li><Link to="/privacy-policy">Gizlilik Politikası</Link></li>
                            <li><Link to="/terms-of-use">Kullanım Koşulları</Link></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h3>İletişim</h3>
                        <ul className="footer-links">
                            <li>
                                <a href="mailto:support@budgetapp.com" className="footer-link">
                                    📧 support@budgetapp.com
                                </a>
                            </li>
                            <li>
                                <a href="https://play.google.com/store/apps/details?id=com.saitgumus.budgetmanagement"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="footer-link">
                                    📱 Google Play Store
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h3>Uygulama Bilgileri</h3>
                        <ul className="footer-links">
                            <li>Paket ID: com.saitgumus.budgetmanagement</li>
                            <li>Versiyon: 1.0.0</li>
                            <li>Platform: Android</li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; 2024 {APP_NAME}. Tüm hakları saklıdır.</p>
                    <p>Geliştirici: Sait Gümüş</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
